import { apiClient } from "./client";

export async function listTeamEmployees() {
  const { data } = await apiClient.get("/team/employees");
  return data;
}

export async function createTeamEmployee(payload) {
  const { data } = await apiClient.post("/team/employees", payload);
  return data;
}

export async function updateTeamEmployee(email, payload) {
  const { data } = await apiClient.patch(`/team/employees/${encodeURIComponent(email)}`, payload);
  return data;
}

export async function deleteTeamEmployee(email) {
  const { data } = await apiClient.delete(`/team/employees/${encodeURIComponent(email)}`);
  return data;
}
